import React, { useState } from 'react';

import { cleanObject } from 'utils/helpers';
import { parseSchedule } from 'utils/recurring';

import TypeSelector from './TypeSelector';
import MonthTypeSelector from './MonthTypeSelector';
import MonthSelector from './MonthSelector';
import DayOfMonthSelector from './DayOfMonthSelector';
import WeekOfMonthSelector from './WeekOfMonthSelector';
import DayOfWeekSelector from './DayOfWeekSelector';
import TimeSelector from './TimeSelector';
import EndSelector from './EndSelector';
import PredefinedOptions from './PredefinedOptions';
import StartingOnSelector from './StartingOnSelector';

const RecurForm = ({ value, end, onEndChange, onChange }) => {
    const [editorVisible, setEditorVisible] = useState(Boolean(value));
    const [predefined, setPredefined] = useState(null);

    const handleSelectPredefined = ({ id, schedule }) => {
        onChange(parseSchedule(schedule, 0));
        setEditorVisible(true);
        setPredefined(id);
    }

    const handleTypeChange = (nextValue, resetOtherFields) => {
        if (resetOtherFields) {
            onChange({
                ...nextValue,
                time: value.time,
                startingOn: undefined
            });
        } else {
            onChange({
                ...value,
                ...nextValue
            });
        }

        setPredefined('custom');
    }

    const handleMonthChange = month => {
        onChange({
            ...value,
            month
        });

        setPredefined('custom');
    }

    const handleDayOfMonthChange = dayOfMonth => {
        onChange({
            ...value,
            dayOfMonth
        });

        setPredefined('custom');
    }

    const handleWeekOfMonthChange = weekOfMonth => {
        onChange({
            ...value,
            weekOfMonth
        });

        setPredefined('custom');
    }

    const handleDayOfWeekChange = dayOfWeek => {
        onChange({
            ...value,
            dayOfWeek
        });

        setPredefined('custom');
    }

    const handleTimeChange = time => {
        onChange({
            ...value,
            time
        });

        setPredefined('custom');
    }

    const handleMonthTypeChange = type => {
        if (type === 'day') {
            onChange(cleanObject({
                ...value,
                dayOfMonth: 1,
                weekOfMonth: undefined,
                dayOfWeek: undefined
            }));
        } else {
            onChange(cleanObject({
                ...value,
                dayOfMonth: undefined,
                weekOfMonth: 1,
                dayOfWeek: [1]
            }));
        }

        setPredefined('custom');
    }

    const handleStartingOnChange = startingOn => {
        onChange({
            ...value,
            startingOn
        });
    }

    return (
        <>
            <PredefinedOptions
                onSelect={handleSelectPredefined}
                selected={predefined}
            />

            <React.Fragment key={predefined}>
                <TypeSelector
                    value={value}
                    onChange={handleTypeChange}
                />

                {
                    value?.type === 'year' ? (
                        <>
                            <MonthSelector
                                value={value}
                                onChange={handleMonthChange}
                            />

                            <DayOfMonthSelector
                                value={value}
                                onChange={handleDayOfMonthChange}
                            />
                        </>
                    ) : (
                        <>
                            {
                                value?.type === 'month' ? (
                                    <>
                                        <StartingOnSelector
                                            value={value}
                                            onChange={handleStartingOnChange}
                                        />

                                        <MonthTypeSelector
                                            value={'weekOfMonth' in value ? 'week' : 'day'}
                                            onChange={handleMonthTypeChange}
                                        />

                                        {
                                            'weekOfMonth' in value ? (
                                                <>
                                                    <WeekOfMonthSelector
                                                        value={value}
                                                        onChange={handleWeekOfMonthChange}
                                                    />

                                                    <DayOfWeekSelector
                                                        value={value}
                                                        onChange={handleDayOfWeekChange}
                                                    />
                                                </>
                                            ) : (
                                                <DayOfMonthSelector
                                                    value={value}
                                                    onChange={handleDayOfMonthChange}
                                                />
                                            )
                                        }
                                    </>
                                ) : (
                                    <DayOfWeekSelector
                                        value={value}
                                        multi={value?.type === 'dayOfMonth' || value?.type === 'dayOfYear'}
                                        onChange={handleDayOfWeekChange}
                                    />
                                )
                            }
                        </>
                    )
                }

                <TimeSelector
                    value={value}
                    onChange={handleTimeChange}
                />

                <EndSelector
                    value={end}
                    onChange={onEndChange}
                />
            </React.Fragment>
        </>
    );
}

export default RecurForm;

